import React, { useEffect } from "react";
import { Controller, useForm, useFieldArray, useWatch } from "react-hook-form";

import InputField from "../../InputField";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useMutation, useQuery } from "react-query";

export default function Profile() {
  const navigate = useNavigate();
  const {
    control,
    setValue,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      bankDetails: [
        {
          id: "",
          currentAccHolderName: "",
          bankName: "",
          accNo: "",
          ifscCode: "",
          branch: "",
          phoneNo: "",
        },
      ],
    },
  });
  const { bankDetails } = watch();

  const { fields, append, remove, replace, insert } = useFieldArray({
    name: "bankDetails",
    control,
  });

  // let profile = JSON.parse(storedData);
  const storedData = sessionStorage.getItem("registerDetails");
  const profile = storedData ? JSON.parse(storedData) : null;

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/register/${profile?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        alert("Profile Updated Successfully");
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
        window.location.reload();
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the profile. Please try again.");
      },
    }
  );

  // setValue
  useEffect(() => {
    if (profile) {
      setValue("companyName", profile?.companyName || "");
      setValue("address", profile?.address || "");
      setValue("type", profile?.type || "");
      setValue("categories", profile?.categories || "");
      setValue("ownerName", profile?.ownerName || "");
      setValue("phoneNumber", profile?.phoneNumber || "");
      setValue("alternativeNumber", profile?.alternativeNumber || "");
      setValue("emailId", profile?.emailId || "");
      setValue("role", profile?.role || "");
      setValue("branchesNumber", profile?.branchesNumber || "");
      setValue("registerDate", profile?.registerDate || "");
      setValue("subscriptionPlan", profile?.subscriptionPlan || "");
      setValue("newPassword", profile?.newPassword || "");
      setValue("confirmPassword", profile?.confirmPassword || "");
      setValue("city", profile?.city || "");
      setValue("state", profile?.state || "");
      setValue("locality", profile?.locality || "");
      setValue("pincode", profile?.pincode || "");
      setValue("no", profile?.no || "");
      setValue("branchType", profile?.branchType || "");
      setValue("gstIn", profile?.gstIn || "");
      setValue("street", profile?.street || "");

      if (profile?.bankDetails?.length > 0) {
        replace(
          profile?.bankDetails?.map((item) => ({
            currentAccHolderName: item?.currentAccHolderName || "",
            bankName: item?.bankName || "",
            accNo: item?.accNo || "",
            ifscCode: item?.ifscCode || "",
            branch: item?.branch || "",
            phoneNo: item?.phoneNo || "",
          }))
        );
      }
    }
  }, [setValue, replace]);

  const onSubmit = (data) => {
    let formData = {
      companyName: data?.companyName,
      address: data?.address,
      type: data?.type,
      categories: data?.categories,
      ownerName: data?.ownerName,
      phoneNumber: data?.phoneNumber,
      alternativeNumber: data?.alternativeNumber,
      emailId: data?.emailId,
      role: data?.role,
      branchesNumber: data?.branchesNumber,
      registerDate: data?.registerDate,
      subscriptionPlan: data?.subscriptionPlan,
      newPassword: data?.newPassword,
      confirmPassword: data?.confirmPassword,
      city: data?.city,
      state: data?.state,
      locality: data?.locality,
      pincode: data?.pincode,
      no: data?.no,
      branchType: data?.branchType,
      gstIn: profile?.gstIn,
      street: data?.street,
      bankDetails: bankDetails,
      logo: "",
    };
    if (formData) {
      if (data?.newPassword == data?.confirmPassword) {
        updateApi(formData);
      } else {
        alert("Password do not match");
      }
    }
  };
  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">
              {profile?.ownerName || "Profile Name"}
            </div>
            {/* <div
              className="header_Btn_container"
              onClick={() => {
                navigate("/setting/profile");
              }}
            >
              Edit Profile
            </div> */}
          </header>
          <section className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form_OverAllContainer">
                <div className="commonForm_container">
                  <div className="input_container">
                    <label className="inputLabel">Mobile Number</label>
                    <Controller
                      control={control}
                      name="phoneNumber"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="tel"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Alter Number</label>
                    <Controller
                      control={control}
                      name="alternativeNumber"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="tel"
                          className="commonInputCss"
                          // placeholder="DD/MM/YYYY"
                        />
                        // <DateField {...field} commonInputCss="commonInputCss" />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Email ID</label>
                    <Controller
                      control={control}
                      name="emailId"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="email"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Type</label>
                    <Controller
                      control={control}
                      name="type"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Category</label>
                    <Controller
                      control={control}
                      name="categories"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  {/* <div className="input_container">
                    <label className="inputLabel">Logo</label>
                    <Controller
                      control={control}
                      name="logo"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="file"
                          commonInputCss="commonInputCss pt-1 ps-1"
                        />
                      )}
                    />
                  </div> */}
                  <div className="input_container">
                    <label className="inputLabel">Shop Name</label>
                    <Controller
                      control={control}
                      name="companyName"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Branch</label>
                    <Controller
                      control={control}
                      name="branchType"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Role</label>
                    <Controller
                      control={control}
                      name="role"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">No</label>
                    <Controller
                      control={control}
                      name="no"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Street</label>
                    <Controller
                      control={control}
                      name="street"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Locality</label>
                    <Controller
                      control={control}
                      name="locality"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">City</label>
                    <Controller
                      control={control}
                      name="city"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">State</label>
                    <Controller
                      control={control}
                      name="state"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Pincode</label>
                    <Controller
                      control={control}
                      name="pincode"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Register Date</label>
                    <Controller
                      control={control}
                      name="registerDate"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="data"
                          className="commonInputCss"
                          readOnly
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">New Password</label>
                    <Controller
                      control={control}
                      name="newPassword"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="password"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Confirm Password</label>
                    <Controller
                      control={control}
                      name="confirmPassword"
                      render={({ field }) => (
                        <input
                          {...field}
                          type="password"
                          className="commonInputCss"
                        />
                      )}
                    />
                  </div>
                </div>

                {fields?.map((item, index) => (
                  <div key={item?.id} className="bankDetails_container">
                    <header>
                      <h6 className="header_title">
                        {" "}
                        Bank Details {index + 1}
                      </h6>
                      <div className="text-end">
                        {/* <button
                          type="button"
                          onClick={() =>
                            insert(index + 1, {
                              currentAccHolderName: "",
                              bankName: "",
                              accNo: "",
                              ifscCode: "",
                              branch: "",
                              phoneNo: "",
                            })
                          }
                          className="append_add_remove_btn"
                          style={{ marginLeft: "8px" }}
                        >
                          Add Below
                        </button> */}
                        <button
                          type="button"
                          onClick={() => remove(index)}
                          className="append_add_remove_btn"
                        >
                          Remove
                        </button>
                      </div>
                    </header>
                    <div className="commonForm_container">
                      <div className="input_container">
                        <label className="inputLabel">
                          Account Holder Name
                        </label>
                        <Controller
                          control={control}
                          name={`bankDetails.${index}.currentAccHolderName`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>

                      <div className="input_container">
                        <label className="inputLabel">Bank Name</label>
                        <Controller
                          control={control}
                          name={`bankDetails.${index}.bankName`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>

                      <div className="input_container">
                        <label className="inputLabel">A/C No</label>
                        <Controller
                          control={control}
                          name={`bankDetails.${index}.accNo`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>

                      <div className="input_container">
                        <label className="inputLabel">IFSC Code</label>
                        <Controller
                          control={control}
                          name={`bankDetails.${index}.ifscCode`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>

                      <div className="input_container">
                        <label className="inputLabel">Branch & Type</label>
                        <Controller
                          control={control}
                          name={`bankDetails.${index}.branch`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>

                      <div className="input_container">
                        <label className="inputLabel">Gpay/Upi Number</label>
                        <Controller
                          control={control}
                          name={`bankDetails.${index}.phoneNo`}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              className="commonInputCss"
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <div>
                  <button
                    type="button"
                    className="append_add_remove_btn"
                    onClick={() =>
                      append({
                        currentAccHolderName: "",
                        bankName: "",
                        accNo: "",
                        ifscCode: "",
                        branch: "",
                        phoneNo: "",
                        id: "",
                      })
                    }
                  >
                    Add Branch
                  </button>
                </div>
              </div>
              <div className="submitBtnContainer">
                <button className="submitBtn" type="submit">
                  {putLoading ? (
                    <>
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </>
  );
}
